<template>
    <span>
        <b-button v-if="id" class="align-baseline" title="Delete" v-b-modal="deleteModalId" variant="link">
            <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </b-button>
        <modal
            :id="deleteModalId"
            :title="`Delete ${modalTitle}`"
            ok-title="Delete"
            :ok-disabled="loading"
            @ok.prevent="deleteHandler"
        >
            <busy-modal :show="loading"></busy-modal>
            Are you sure you want to delete this {{ modalTitle }}?
        </modal>
    </span>
</template>

<script>
    import { mapGetters } from 'vuex';
    import API from '../../api';
    import Modal from '../generic/modal/modal.vue';
    import BusyModal from '../generic/busy-modal/busy-modal.vue';
    import FormInput from '../generic/form-input/form-input.vue';
    import FormTextarea from '../generic/form-textarea/form-textarea.vue';
    import FormCheckbox from '../generic/form-checkbox/form-checkbox.vue';
    import FormDatepicker from '../generic/form-datepicker/form-datepicker.vue';
    import { formatResponseError } from '../../utils/api';
    import { OWNER_STATEMENT_ENDPOINT } from '../../endpoints';

    export default {
        components: {
            Modal,
            BusyModal,
            FormInput,
            FormTextarea,
            FormCheckbox,
            FormDatepicker,
        },
        data() {
            return {
                loading: false,
                id: null,
                deleteModalId: '',
                actionField: '',
            };
        },
        created() {
            this.actionField = this.params.colDef.field;
            this.id = this.params.data && this.params.data.id;
            this.statementId = this.params.data && this.params.data.statement_id;
            this.deleteModalId = `modal-delete-${this.id}`;
        },
        computed: {
            ...mapGetters('header', ['userUnicodeDateFormat']),
            modalTitle() {
                return this.actionField === 'reservations_action'
                    ? 'Reservation Record'
                    : this.actionField === 'work_order_action'
                    ? 'Work Order Record'
                    : 'Expense Record';
            },
        },
        methods: {
            async deleteHandler() {
                return this.actionField === 'reservations_action'
                    ? await this.deleteReservation()
                    : this.actionField === 'work_order_action'
                    ? await this.deleteWorkOrder()
                    : await this.deleteRentalExpense();
            },
            async deleteReservation() {
                this.loading = true;
                try {
                    const { data } = await API.post(
                        OWNER_STATEMENT_ENDPOINT(this.statementId) + 'delete-reservation/',
                        { reservation_id: this.id }
                    );
                    this.params.onDeleteReservationSuccess(data);
                } catch (err) {
                    const { generic, fields } = formatResponseError(err);
                    this.errorToast({ text: generic || `Could not delete ${this.modalTitle}.` });
                } finally {
                    this.loading = false;
                    this.$bvModal.hide(this.deleteModalId);
                }
            },
            async deleteWorkOrder() {
                this.loading = true;
                try {
                    const { data } = await API.post(OWNER_STATEMENT_ENDPOINT(this.statementId) + 'delete-work-order/', {
                        work_order_id: this.id,
                    });
                    this.params.onDeleteWorkOrderSuccess(data);
                } catch (err) {
                    const { generic, fields } = formatResponseError(err);
                    this.errorToast({ text: generic || `Could not delete ${this.modalTitle}.` });
                } finally {
                    this.loading = false;
                    this.$bvModal.hide(this.deleteModalId);
                }
            },
            async deleteRentalExpense() {
                this.loading = true;
                try {
                    const { data } = await API.post(
                        OWNER_STATEMENT_ENDPOINT(this.statementId) + 'delete-rental-expense/',
                        { rental_expense_id: this.id }
                    );
                    this.params.onDeleteRentalExpenseSuccess(data);
                } catch (err) {
                    const { generic, fields } = formatResponseError(err);
                    this.errorToast({ text: generic || `Could not delete ${this.modalTitle}.` });
                } finally {
                    this.loading = false;
                    this.$bvModal.hide(this.deleteModalId);
                }
            },
        },
    };
</script>
